import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, IconButton, Tooltip } from '@dixa/lib-shared-habla';
import { useEffect, useState } from 'react';
import { useCopyToClipboard } from 'react-use';
export const WebformEndpointsTableActions = ({ id, description, endpointUrl, handleDeleteWebformEndpoint, }) => {
    const [_, copyToClipboard] = useCopyToClipboard();
    const [isCopied, setIsCopied] = useState(false);
    useEffect(() => {
        const timeoutId = isCopied
            ? window.setTimeout(() => setIsCopied(false), 3000)
            : undefined;
        return () => window.clearTimeout(timeoutId);
    }, [isCopied]);
    return (_jsxs(FlexBox, Object.assign({ flexDirection: "row" }, { children: [_jsx(Tooltip, Object.assign({ content: isCopied ? 'Copied' : 'Copy URL', dark: true }, { children: _jsx(IconButton, { variant: "tertiary", icon: isCopied ? 'done' : 'copy', onClick: () => {
                        copyToClipboard(endpointUrl);
                        setIsCopied(true);
                    } }) })), _jsx(Tooltip, Object.assign({ content: "Delete", dark: true }, { children: _jsx(IconButton, { variant: "tertiary", icon: "trash", onClick: () => handleDeleteWebformEndpoint({
                        id,
                        description,
                    }) }) }))] })));
};
